import momentTimezone from 'moment-timezone';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import {PlatformIntl} from '../infra/PlatformIntl';

momentDurationFormatSetup(moment);

// Evento tem `eventTime` e so isso -- `serverTime` e campo de posicao e nunca chegou aqui. Como
// `moment(undefined)` devolve o instante atual sem reclamar, pedir o campo errado fazia a tela
// mostrar a hora em que ela desenhou no lugar da hora do evento, e ninguem percebia porque a lista
// e desenhada no instante em que a notificacao chega, quando as duas coincidem.
export const formatEventTime = (event, format = 'L LT') => {
  const {eventTime} = event || {};

  if (!eventTime) return PlatformIntl.getInstance().formatMessage('notAvailable');

  return moment(eventTime).format(format);
};

export const timezoneFormat = (timeZone, date) =>
  momentTimezone(date)
      .tz(timeZone)
      .format();

export const dateToDate = (start, end) => ({
  from: moment.utc(moment(start)).format(),
  to: moment.utc(moment(end)).format(),
});

export const nowSofar = () => ({
  from: moment.utc(moment().startOf('day')).format(),
  to: moment.utc().format(),
});

export const currentWeekSoFar = () => ({
  from: moment.utc(moment().startOf('week')).format(),
  to: moment.utc().format(),
});

export const yesterday = () => ({
  from: moment
      .utc(
          moment()
              .add(-1, 'day')
              .startOf('day'),
      )
      .format(),
  to: moment
      .utc(
          moment()
              .add(-1, 'day')
              .endOf('day'),
      )
      .format(),
});

export const lastWeek = () => ({
  from: moment
      .utc(
          moment()
              .day(-7)
              .startOf('week'),
      )
      .format(),
  to: moment
      .utc(
          moment()
              .day(-7)
              .endOf('week'),
      )
      .format(),
});

export const currentMonthSoFar = () => ({
  from: moment.utc(moment().startOf('month')).format(),
  to: moment.utc().format(),
});

export const lastMonth = () => ({
  from: moment
      .utc(
          moment()
              .subtract(1, 'month')
              .startOf('month'),
      )
      .format(),
  to: moment
      .utc(
          moment()
              .subtract(1, 'month')
              .endOf('month'),
      )
      .format(),
});

export const durationFormat = (milliseconds, format) =>
  moment.duration(milliseconds, 'milliseconds').format(format, {trim: false});

export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss', tz) => {
  if (tz) {
    return moment(date).tz(tz).format(format);
  }

  return moment(date).format(format);
};

/**
 * Formats a timestamp as human-readable elapsed time in the user's locale.
 * Returns relative time without suffix (e.g., "2 minutos", "3 horas", "5 dias").
 *
 * @param {string|number|Date} timestamp - The timestamp to format
 * @return {string} Localized elapsed time (pt-BR: "2 minutos", en: "2 minutes")
 *
 * @example
 * formatElapsedTime('2026-01-31T10:00:00Z') // "2 horas" (if current time is 12:00)
 * formatElapsedTime(Date.now() - 300000) // "5 minutos"
 */
export const formatElapsedTime = (timestamp) => {
  return moment(timestamp).fromNow(true);
};
